import { Dialog } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import { IUnityErrorDialog } from '~/views/types';

export const UnityErrorDialog: FC<IUnityErrorDialog> = observer(props => {
    const mainText =
        props.error?.description || 'One Of The Fields Seems Incorrect. Please Try Again Later Or Contact Support.';

    return (
        <Dialog open={true} className="hr-modal-dialog">
            <div className="modal-dialog modal-dialog-centered alert-dialog unity-error-dialog" role="document">
                <div className="modal-content">
                    <div className="modalContent">
                        <div className="modal-body">
                            <div className="unity-logo-wrap-modal">
                                <figure>
                                    <img className="unity-logo-modal" src="/assets/img/unity-logo-modal.svg" />
                                    <img
                                        className="unity-logo-modal-mobile"
                                        src="/assets/img/unity-logo-modal-mobile.svg"
                                    />
                                </figure>
                            </div>
                            <h3>Something went wrong</h3>
                            <div className="unity-form-wrap">
                                <p>{mainText}</p>
                                <p className="not-success-mail">
                                    <a href="mailto:customercare@unitybyhardrock.com">
                                        customercare@unitybyhardrock.com
                                    </a>
                                </p>
                            </div>
                            <div className="link-unity-btn-wrap">
                                <button
                                    type="button"
                                    id="link-unity-btn2"
                                    className="btn"
                                    onClick={props.onButtonClick}
                                >
                                    OK
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    );
});
